export const SupportModule = ({
  title,
  description,
  cta,
  cta_style,
  cta_description,
  contacts,
}) => {
  let ctaStyle = "bg-error";
  if (cta_style === "jay-blue") {
    ctaStyle = "bg-jay-blue";
  }
  if (cta_style === "light-blue") {
    ctaStyle = "bg-jay-blue";
  }

  return (
    <div>
      {title && (
        <>
          <h2 className="text-jay-blue text-base m-0 mb-6">{title}</h2>
          <hr className="mb-6 border-t border-solid border-gray" />
        </>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          {description && (
            <div
              dangerouslySetInnerHTML={{ __html: description }}
              className="text-lg text-black"
            />
          )}
        </div>
        <div>
          {cta && (
            <a
              href={cta.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${ctaStyle} text-white h-14 text-lg inline-flex justify-center items-center px-4 py-2 mb-4`}
            >
              {cta.title}
            </a>
          )}
          {cta_description && (
            <div
              dangerouslySetInnerHTML={{ __html: cta_description }}
              className="text-xs text-gray"
            />
          )}
        </div>
        <div>
          {contacts && (
            <ul>
              {contacts.map((contact, i) => (
                <li key={i} className="text-base mb-4 flex flex-col">
                  {contact.department && (
                    <div className="font-bold">{contact.department}</div>
                  )}
                  {contact.name && <div>{contact.name}</div>}
                  {contact.phone && (
                    <a
                      href={`tel:${contact.phone}`}
                      className="text-red underline hover:no-underline"
                    >
                      {contact.phone}
                    </a>
                  )}
                  {contact.email && (
                    <a
                      href={`mailto:${contact.email}`}
                      className="text-red underline hover:no-underline"
                    >
                      {contact.email}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
